import React from 'react';
import PropTypes from 'prop-types';
import { getDay, getHours, getMinutes, getPeriod } from './date-fns';
import { Button, Select, TimeInput } from '../../../components';

const DAY_OPTIONS = [
	{ value: 0, label: 'Sunday' },
	{ value: 1440, label: 'Monday' },
	{ value: 2880, label: 'Tuesday' },
	{ value: 4320, label: 'Wednesday' },
	{ value: 5760, label: 'Thursday' },
	{ value: 7200, label: 'Friday' },
	{ value: 8640, label: 'Saturday' },
];

export default class TemplateItemRow extends React.Component {
	static propTypes = {
		templateItem: PropTypes.object,
		onCancel: PropTypes.func,
		onEdit: PropTypes.func,
		onDelete: PropTypes.func,
		onDone: PropTypes.func.isRequired,
		disable: PropTypes.bool
	}

	state = {
		editting: false,
		showButtons: false,
	}

	constructor(props) {
		super(props);

		this.state = {
			editting: !props.templateItem.id
		};
	}

	componentDidMount() {
		if (!this.props.templateItem.id) {
			this.handleEditToggle();
		}
	}

	handleMouseEnter = () => {
		this.setState({ showButtons: true });
	}

	handleMouseLeave = () => {
		this.setState({ showButtons: false });
	}

	handleDone = () => {
		// convert input values to start_time, end_time
		const {
			startDay = '0', startHour = '0', startMinute = '0', startPeriod = '0',
			endDay = '0', endHour = '0', endMinute = '0', endPeriod = '0'
		} = this.state;

		const newStartTime = parseInt(startDay) + parseInt(startHour) + parseInt(startMinute) + parseInt(startPeriod);
		const newEndTime = parseInt(endDay) + parseInt(endHour) + parseInt(endMinute) + parseInt(endPeriod);
		this.props.onDone(this.props.templateItem, newStartTime, newEndTime);
		this.setState({ editting: false });
	}

	handleCancel = () => {
		this.setState({ editting: false });
		if (this.props.onCancel) {
			this.props.onCancel();
		}
	}

	handleEditToggle = () => {
		const { templateItem } = this.props;
		// convert start_time, end_time to input values
		this.setState({
			editting: true,
			startDay: `${Math.floor(templateItem.start_time / 1440) * 1440}`,
			startHour: `${getHours(templateItem.start_time, false)}`,
			startMinute: `${getMinutes(templateItem.start_time, false)}`,
			startPeriod: `${getPeriod(templateItem.start_time, false)}`,
			endDay: `${Math.floor(templateItem.end_time / 1440) * 1440}`,
			endHour: `${getHours(templateItem.end_time, false)}`,
			endMinute: `${getMinutes(templateItem.end_time, false)}`,
			endPeriod: `${getPeriod(templateItem.end_time, false)}`,
		});
		if (this.props.onEdit) {
			this.props.onEdit();
		}
	}

	handleDelete = () => {
		this.props.onDelete(this.props.templateItem);
	}

	handleStartDayChange = ({ target }) => {
		this.setState({ startDay: target.value });
	}

	handleStartTimeChange = ({ hour, minute, period }) => {
		this.setState({
			startHour: hour,
			startMinute: minute,
			startPeriod: period
		});
	}

	handleEndDayChange = ({ target }) => {
		this.setState({ endDay: target.value });
	}

	handleEndTimeChange = ({ hour, minute, period }) => {
		this.setState({
			endHour: hour,
			endMinute: minute,
			endPeriod: period
		});
	}

	render() {
		const { templateItem, disable } = this.props;
		const {
			editting, showButtons,
			startDay, startHour, startMinute, startPeriod,
			endDay, endHour, endMinute, endPeriod
		} = this.state;

		return (
			<tr onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
				<td>
					{editting ? (
						<Select
							options={DAY_OPTIONS}
							selectedValue={startDay}
							onChange={this.handleStartDayChange}
						/>
					) : (
						getDay(templateItem.start_time)
					)}
				</td>
				<td>
					{editting ? (
						<TimeInput
							hour={startHour}
							minute={startMinute}
							period={startPeriod}
							onChange={this.handleStartTimeChange}
						/>
					) : (
						`${getHours(templateItem.start_time)}:${getMinutes(templateItem.start_time)}${getPeriod(templateItem.start_time)}`
					)}
				</td>
				<td>
					{editting ? (
						<Select
							options={DAY_OPTIONS}
							selectedValue={endDay}
							onChange={this.handleEndDayChange}
						/>
					) : (
						getDay(templateItem.end_time)
					)}
				</td>
				<td>

					{editting ? (
						<TimeInput
							hour={endHour}
							minute={endMinute}
							period={endPeriod}
							onChange={this.handleEndTimeChange}
						/>
					) : (
						`${getHours(templateItem.end_time)}:${getMinutes(templateItem.end_time)}${getPeriod(templateItem.end_time)}`
					)}
				</td>
				<td className="text-right">
					<Button title="Done" shown={editting} onClick={this.handleDone} />
					<Button title="Cancel" shown={editting} onClick={this.handleCancel} />
					<Button shown={!editting} visible={showButtons} onClick={this.handleEditToggle} disabled={disable} />
					<Button shown={!editting} visible={showButtons} danger isDelete onClick={this.handleDelete} disabled={disable} />
				</td>
			</tr>
		);
	}
}
